module.exports = __webpack_public_path__ + "img/industry5_active.ed6d5bd7.png";